import React from 'react';
import propTypes from 'prop-types';
export const PhoneIcon = ({ size = 18, color = 'none', variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      height={sizeInPixel}
      width={sizeInPixel}
      className={variant}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 287.32 287.32"
      xmlSpace="preserve"
    >
      <path
        d="M267.749,191.076c-14.595-11.729-27.983-17.431-40.93-17.431c-18.729,0-32.214,11.914-44.423,24.119
	c-1.404,1.405-3.104,2.06-5.349,2.06c-10.288,0.001-28.387-12.883-53.794-38.293c-29.89-29.892-41.191-48.904-33.592-56.506
	c20.6-20.593,27.031-41.237-4.509-80.462C73.861,10.51,62.814,3.68,51.38,3.68c-15.42,0-27.142,12.326-37.484,23.202
	c-1.788,1.88-3.477,3.656-5.133,5.312c-11.689,11.688-11.683,37.182,0.017,68.2c12.837,34.033,38.183,71.055,71.37,104.247
	c25.665,25.663,53.59,46.403,80.758,60.328c23.719,12.158,46.726,18.672,64.783,18.672c0.002,0,0.004,0,0.007,0
	c11.3,0,20.479-2.465,26.541-7.478c12.314-10.181,35.234-29.039,35.081-51.439C287.236,212.71,280.653,201.451,267.749,191.076z"
      />
    </svg>
  );
};
PhoneIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
};
PhoneIcon.defaultProps = {
  size: 18,
  color: 'black',
};
